var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreaming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_streaming)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5, 4.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4267C7",
    cx: 1.65,
    cy: 1.65,
    rx: 1.65,
    ry: 1.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4267C7",
    cx: 1.65,
    cy: 7.65,
    rx: 1.65,
    ry: 1.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4267C7",
    cx: 1.65,
    cy: 13.65,
    rx: 1.65,
    ry: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4267C7",
    cx: 16.5,
    cy: 7.65,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,8.5 L8,8.5 C8.13,8.28 8.27,8.07 8.42,7.87 L8.62,7.58 C8.41,7.29 8.21,7 8,6.63 L4.5,6.63 C4.57,6.87 4.61,7.11 4.63,7.36 L4.63,7.73 C4.61,7.98 4.57,8.23 4.5,8.5 Z",
    fill: "#669DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,4.8 L10.6,4.43 L10.35,4 L9.95,3.2 C8.8,1 7.6,0 5.2,0 L4.5,0 C4.58,0.3 4.62,0.61 4.63,0.92 C4.63,1.23 4.59,1.54 4.5,1.84 L5.2,1.84 C6.65,1.84 7.3,2.3 8.2,3.9 L8.42,4.29 L8.64,4.73 C9.95,7.3 10.9,8.3 13.1,8.52 C13.03,8.23 12.99,7.92 12.99,7.61 C12.99,7.3 13.03,6.99 13.12,6.68 L13.17,6.68 C12.1,6.58 11.5,6.12 10.8,4.8 Z",
    fill: "#4267C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,9.5 L8.88,9.92 L8.53,10.6 L8.31,11.02 L8.1,11.4 C7.25,12.85 6.6,13.28 5.2,13.28 L4.5,13.28 C4.57,13.52 4.61,13.77 4.63,14.02 L4.63,14.35 C4.61,14.6 4.57,14.85 4.5,15.09 L5.15,15.09 C7.35,15.03 8.55,13.95 9.73,11.75 L10.22,10.78 L10.41,10.43 L10.58,10.13 C10.71,9.9 10.86,9.68 11.02,9.47 C10.45,9.26 9.92,8.95 9.46,8.56 C9.23,8.87 9.03,9.19 8.86,9.53 L9.1,9.5 Z",
    fill: "#669DF6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 0.75V1.5H19C20.93 1.5 22.5 3.07 22.5 5V19C22.5 20.93 20.93 22.5 19 22.5H5C3.07 22.5 1.5 20.93 1.5 19V5C1.5 3.07 3.07 1.5 5 1.5V0C2.24 0 0 2.24 0 5V19C0 21.76 2.24 24 5 24H19C21.76 24 24 21.76 24 19V5C24 2.24 21.76 0 19 0H5V0.75Z",
    fill: "#4267C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_streaming"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreaming);
export default __webpack_public_path__ + "static/media/streaming.31c8053d83ab4563f80c6480b25c165b.svg";
export { ForwardRef as ReactComponent };